<template>
  <div>
    <b-row>
      <b-col class="d-flex justify-content-between pb-1 align-items-center">
        <h1 class="font-weight-bolder">
          {{ $t('users') }}
        </h1>
        <b-button
          :to="{ name: 'new-user' }"
          variant="primary"
        >
          {{ $t('create', { type: $t('user') }) }}
        </b-button>
      </b-col>
    </b-row>
    <b-row class="mb-1">
      <b-col md="6" lg="5">
        <b-form-group
          :label="$t('search') || 'Buscar'"
          label-for="users-search"
        >
          <b-input-group>
            <b-form-input
              id="users-search"
              v-model.trim="searchQuery"
              placeholder="Nombre, correo, teléfono o empresa"
              @keyup.enter="applySearch"
            />
            <b-input-group-append>
              <b-button
                variant="outline-primary"
                @click="applySearch"
              >
                {{ $t('search') || 'Buscar' }}
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <users-table
          :users="users"
          :pagination="pagination"
          :search-query="searchQuery"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import UsersTable from '@/views/users/UsersTable.vue'

export default {
  components: {
    UsersTable,
  },
  data() {
    return {
      searchQuery: '',
    }
  },
  computed: {
    ...mapGetters('users', ['users', 'pagination']),
  },

  created() {
    this.fetchData()
  },

  methods: {
    ...mapMutations('users', {
      changePage: 'CHANGE_PAGE',
    }),
    ...mapActions('users', ['fetchUsers']),

    fetchData() {
      const params = {
        by_active_status: true,
      }

      if (this.searchQuery) {
        params.q = this.searchQuery
      }

      this.fetchUsers(params)
    },

    applySearch() {
      this.changePage(1)
      this.fetchData()
    },
  },
}
</script>

<style></style>
